const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
const API_ROOT_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '').replace(/\/$/, '');

function isAbsoluteMediaUrl(value: string): boolean {
  return (
    /^(?:[a-z][a-z\d+\-.]*:)?\/\//i.test(value) ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  );
}

export function resolveApiMediaUrl(url?: string | null): string | null {
  const value = url?.trim();
  if (!value) return null;
  if (isAbsoluteMediaUrl(value)) return value;

  if (value.startsWith('/uploads/')) {
    return `${API_ROOT_URL}${value}`;
  }

  return value;
}
